import React from 'react'
import CalendarMonthListItem from './CalendarMonthListItem'

const CalendarMonthList = ({
  monthList,
  selectMonth,
  selectedMonth,
  selectDay,
  selectedDay,
  formatSubmissionSurvey,
  strings,
  sendEvent,
  selectedLocale,
  fetchInstrument,
  setSubmissionSurvey,
  displayingList,
  humiIsabellaDisabled,
  onLeftArrowClick,
  onRightArrowClick,
  leftArrowDisabled,
  rightArrowDisabled,
  fullMonthList,
  expiredInstruments,
  completedInstruments,
  availableInstruments,
  allInstances,
  studyId,
  selectedLine,
  selectLine,
  participantId,
  firstLogin,
  confirmedVisitKeys = [],
}) => {
  const getIndex = month => {
    return fullMonthList.findIndex(
      item => item?.value === month?.value && item?.year === month?.year,
    )
  }
  return (
    <div className='calendar-month-list'>
      {monthList.map((month, idx) => (
        <CalendarMonthListItem
          key={idx}
          month={month}
          selectMonth={selectMonth}
          selectedMonth={selectedMonth}
          index={idx}
          monthIndex={getIndex(month)}
          selectDay={selectDay}
          selectedDay={selectedDay}
          formatSubmissionSurvey={formatSubmissionSurvey}
          strings={strings}
          sendEvent={sendEvent}
          selectedLocale={selectedLocale}
          fetchInstrument={fetchInstrument}
          setSubmissionSurvey={setSubmissionSurvey}
          displayingList={displayingList}
          humiIsabellaDisabled={humiIsabellaDisabled}
          onLeftArrowClick={onLeftArrowClick}
          onRightArrowClick={onRightArrowClick}
          leftArrowDisabled={leftArrowDisabled}
          rightArrowDisabled={rightArrowDisabled}
          expiredInstruments={expiredInstruments}
          completedInstruments={completedInstruments}
          availableInstruments={availableInstruments}
          allInstances={allInstances}
          studyId={studyId}
          selectedLine={selectedLine}
          selectLine={selectLine}
          monthList={monthList}
          participantId={participantId}
          firstLogin={firstLogin}
          confirmedVisitKeys={confirmedVisitKeys}
        />
      ))}
    </div>
  )
}

export default CalendarMonthList
